<template>
  <global-wrapper
    :loading="$apollo.queries.pengguna.loading"
    :loadingType="'TwoLine'"
    :loadingList="5"
    :empty="false"
    :error="false"
  >
    <div id="profile-page">
      <div class="vx-row">
        <Avatar :pengguna="pengguna" @refreshPengguna="refreshPenggunaQuery"/>
        <Detail :pengguna="pengguna" @refreshPengguna="refreshPenggunaQuery"/>
        <UserBidang />
      </div>
    </div>
  </global-wrapper>
</template>

<script>
import { FIND } from "@/query/pengguna";

import Detail from "./components/Detail.vue";
import UserBidang from "./components/UserBidang.vue";
import Avatar from "./components/Avatar.vue";

export default {
  components: {
    Detail,
    UserBidang,
    Avatar
  },
  data() {
    return {
      pengguna: {}
    };
  },
  apollo: {
    pengguna: {
      query: FIND,
      update: data => {
        return data.pengguna;
      },
      variables() {
        return {
          where: { column: "UUID", value: this.$sanctum.getUser().uuid }
        };
      }
    }
  },
  methods: {
    refreshPenggunaQuery() {
      this.$apollo.queries.pengguna.refetch();
      this.$store.dispatch("updateAvatar", this.pengguna.avatar);
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
</style>
